import { EditorState, Plugin, Transaction } from 'prosemirror-state'
import { closeHistory } from 'prosemirror-history'

export const JoinListsMetaKey = 'joinLists'

// NOTE: this works in conjunction with the `joinLists` command to dispatch two seperate transactions
export const JoinLists = new Plugin({
  appendTransaction: (transactions: Transaction[], oldState: EditorState, newState: EditorState) => {
    let originTr
    if (!!(originTr = transactions.find((tr) => tr.getMeta(JoinListsMetaKey)))) {
      const tr = newState.tr.join(originTr.getMeta(JoinListsMetaKey))
      closeHistory(tr)

      return tr
    }
  },
})
